// if name and/or number arent returned from the api, they are already set to an empty string
const formatStreet = (number, name, country) => {
  let street = '';
  // only add blank space if needed
  const blankSpace = number !== '' && name !== '' ? ' ' : '';

  switch (country) {
    case 'it':
      street = `${name}${blankSpace}${number}`;
      break;
    default:
      street = `${number}${blankSpace}${name}`;
  }
  return street;
};

const formatJP = (
  addressComponents = [],
  city = '',
  postcode = '',
) => {
  if (addressComponents.length > 0 && city) {
    // map through each item of the addressComponents until we reach the city value
    // get index of city value
    const cityIndex = addressComponents.findIndex(
      // eslint-disable-next-line camelcase
      ({ long_name }) => long_name === city,
    );

    if (cityIndex !== -1) {
      // now we have a new array of only street values, maybe a postcode, so we have to do another test
      const n = addressComponents.slice(0, cityIndex);

      // some street addresses also return a postcode
      // lets see if that also exists
      // get index of postcode value and remove it from array
      const postCodeIndex = n.findIndex(
        // eslint-disable-next-line camelcase
        ({ long_name }) => long_name === postcode,
      );

      if (postCodeIndex !== -1) n.splice(postCodeIndex, 1);

      // when/if you hit a “premise” add a hyphen
      // if not complete, and there is another “premise” add a space
      let streetName = '';
      let counter = 0;
      n.toReversed().map((item) => {
        if (item.types.includes('premise')) {
          if (counter === 0)
            streetName =
              streetName !== ''
                ? `${streetName}-${item.long_name}`
                : `${item.long_name}`;
          else streetName = `${streetName} ${item.long_name}`;
          counter += 1;
        } else {
          streetName = `${streetName}${item.long_name}`;
        }
        return item; // map requires a return value, but it's not used here
      });
      return streetName;
    }
    // city not found in array
    return '';
  }
  // array is empty or city name is empty
  return '';
};

const formatKR = (
  addressComponents = [],
  city = '',
  postcode = '',
) => {
  if (addressComponents.length > 0 && city) {
    // map through each item of the addressComponents until we reach the city value
    // get index of city value
    const cityIndex = addressComponents.findIndex(
      // eslint-disable-next-line camelcase
      ({ long_name }) => long_name === city,
    );

    if (cityIndex !== -1) {
      // now we have a new array of only street values, maybe a postcode, so we have to do another test
      const n = addressComponents.slice(0, cityIndex);

      // some street addresses also return a postcode
      // lets see if that also exists
      // get index of postcode value and remove it from array
      const postCodeIndex = n.findIndex(
        // eslint-disable-next-line camelcase
        ({ long_name }) => long_name === postcode,
      );

      if (postCodeIndex !== -1) n.splice(postCodeIndex, 1);

      // when/if you hit a “premise” add a hyphen
      // if not complete, and there is another “premise” add a space
      let streetName = '';
      let counter = 0;
      n.toReversed().map((item) => {
        if (item.types.includes('premise')) {
          if (counter === 0)
            streetName =
              streetName !== ''
                ? `${streetName} ${item.long_name}`
                : `${item.long_name}`;
          else streetName = `${streetName} ${item.long_name}`;
          counter += 1;
        } else {
          streetName = `${streetName} ${item.long_name}`;
        }
        return item; // map requires a return value, but it's not used here
      });

      return streetName;
    }
    // city not found in array
    return '';
  }
  // array is empty or city name is empty
  return '';
};

export { formatStreet, formatJP, formatKR };
